import { render } from "./PaymentConfirmationModal.vue?vue&type=template&id=066071c6"
import script from "./PaymentConfirmationModal.vue?vue&type=script&lang=js"
export * from "./PaymentConfirmationModal.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__